import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PricePlan } from 'models';

@Injectable({
	providedIn: 'root',
})
export class PricePlanService {
	constructor(private http: HttpClient) {}

	get(userId: string): Observable<PricePlan[]> {
		return this.http.get<PricePlan[]>(`api/priceplan/get/${userId}`);
	}

	save(userId: string, pricePlan: PricePlan): Observable<null> {
		return this.http.post<null>(`api/priceplan/save/${userId}`, pricePlan);
	}

	update(userId: string, pricePlan: PricePlan): Observable<null> {
		return this.http.put<null>(`api/priceplan/update/${userId}`, pricePlan);
	}
}
